import React from 'react';
import { CoursePrice } from '../data/packagesData';
import PackageCard from './PackageCard';

type SessionPackagesProps = {
  courses: CoursePrice[];
};

const SessionPackages: React.FC<SessionPackagesProps> = ({ courses }) => (
  <div className={`grid grid-cols-1 gap-7 ${courses.length === 3 ? 'md:grid-cols-2 xl:grid-cols-3' : 'mx-auto max-w-4xl md:grid-cols-2'}`}>
    {courses.map((course) => (
      <PackageCard key={`${course.sessionType}-${course.title}`} course={course} />
    ))}
  </div>
);

export default SessionPackages;
